module.exports = __webpack_public_path__ + "img/u603.498aa1ef.svg";